export const DataType = Object.freeze({
  ACTIVITY: "ACTIVITY",
  LEAVE_REQUEST: "LEAVE_REQUEST"
});
